<template>
    <div>
        <div class="d-flex tab-container gap-2 mb-3">
            <router-link class="tab" to="/training/enrolled">Enrolled Training</router-link>
            <router-link class="tab" to="/training/catalog" >All Trainings</router-link>
        </div>
        <router-view />
    </div>
</template>

<script>
import { adminNavBarRoutes } from '../config/navigation-route';
import { assigneeNavBarRoutes } from '../config/navigation-route';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('Auth');
export default {
    name: 'AuthLayout',
    data() {
        return {
            adminNavBarRoutes,
            assigneeNavBarRoutes,
        };
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
        }),
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';
.entity-section {
    padding: 20px;
    padding-top: 90px;
    min-height: 100vh;
    background-color: #f0f3f6;
}

.tab {
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-2;
    width: fit-content;
    border-radius: $field-border-radius-high;
    padding: 5px 15px;
    text-decoration: none;
    background-color: $light-300;
    color: $dark-300;
}

.tab:hover {
    cursor: pointer;
}

.active {
    background-color: $primary-100;
    color: $white;
}


// .popup {
//   position: absolute;
//   top: 0;
//   left: calc(50% - 5px);
//   animation: move 2s 1;
//   // background-color: red;
//   // height: 10px;
//   transform: translateY(0);
//   // width: 10px;
// }

// @keyframes move {
//   0%, 100% {transform: translateY(0)}
//   50% {transform: translateY(90px)}
// }
</style>
